import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Venta } from "@/shared/types/venta";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface VentaRequest {
    clienteId: string;
    vendedorId: string,
    fecha?: string;
    credito?: boolean;
    presupuesto?: boolean,
    saltarFE?: boolean,
    items: VentaItemRequest[],
    token?: string,
}

export interface VentaItemRequest {
    articuloId: string;
    cantidad: number;
    precioIndex: number,
    precioUnitario?: number;
}

export async function addVenta({ token, ...request }: VentaRequest): Promise<Venta> {
    await sleep(1000);
    const response = await api.post("ventas", request, { headers: { "X-Venta-Token": token } });
    return response.data;
}

export function useAddVentaMutation(mutationConfig: MutationConfig<Venta, VentaRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: addVenta,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["ventas"] });
        },
    })
}

export interface AddVentaMutationProps {
    mutationConfig?: MutationConfig<Venta, VentaRequest>
    children?: (mutationResult: MutationResult<Venta, VentaRequest>) => ReactNode
}

export function AddVentaMutation({
    mutationConfig,
    children
}: AddVentaMutationProps) {
    const mutationResult = useAddVentaMutation(mutationConfig);
    return children && children(mutationResult);
}